import { queryOptions } from '@tanstack/react-query';
import { getLeaderboard } from '../endpoints/leaderboard';
import type { LeaderboardCategory } from '@/types/leaderboard';

export const LEADERBOARD_QUERY_KEYS = {
  all: ['leaderboard'] as const,
  category: (category: LeaderboardCategory) =>
    [...LEADERBOARD_QUERY_KEYS.all, category] as const,
} as const;

export const leaderboardQueryOptions = (category: LeaderboardCategory) =>
  queryOptions({
    queryKey: LEADERBOARD_QUERY_KEYS.category(category),
    queryFn: () => getLeaderboard(category),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 15,
  });
